module.exports = [{
      plugin: require('C:/Users/alex/Desktop/Projects/heyimalex-gatsby/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":590},
    },{
      plugin: require('C:/Users/alex/Desktop/Projects/heyimalex-gatsby/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/alex/Desktop/Projects/heyimalex-gatsby/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/alex/Desktop/Projects/heyimalex-gatsby/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    }]
